// extracted by mini-css-extract-plugin
export default {"message":"RelativeToPatientPopup_message__hBQHK"};